<template>
  <v-sheet height="100%" class="neu-glow-inset">
    <v-container class="fill-height justify-center" fluid>
      <v-row align="center" justify="center">
        <v-col cols="10" lg="6">
          <v-sheet class="neu-glow with-radius fill-height" height="100%">
            <v-img
              src="/static/ob-animated-isometric/qr-code-animate.svg"
              lazy-src="/static/ob-animated-isometric/qr-code-animate.svg"
              height="300"
              contain
            >
            </v-img>
            <v-row justify="end" class="fill-height">
              <v-col class="text-center px-3 mt-5" cols="12">
                <v-card class="mx-5 neu-glow">
                  <v-card-title class="d-flex justify-center font-weight-black">
                    Abilita Notifiche PUSH
                  </v-card-title>
                  <div class="  justify px-5">
                    <div class="pb-5">
                      Per ricevere le notifiche sul questo cellulare, concedi l'autorizzazione, quindi clicca qui sotto per verificare lo status
                    </div>
                    <div v-if="!pushSubscribed" class="d-flex justify-center">
                      <v-btn
                        color="info"
                        @click="verifyPush()"
                        class="mb-5"
                        >
                        Verifica
                      </v-btn>
                    </div>
                    <div v-else>
                      <div>
                        <v-icon color="info" style="font-size:70px">mdi-check-circle</v-icon>
                      </div>
                      <v-btn
                        color="info"
                        to="../../manage"
                        class="mb-5"
                        >
                        Prosegui
                      </v-btn>
                    </div>
                  </div>
                </v-card>            
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>


<script>
import { mapGetters } from "vuex";
export default {
  computed :{
      ...mapGetters(["settings"]),
  },
  watch:{
      'settings': function (newVal)
      {
        console.log(63,'pushSubscribed',newVal)
      },
  },  
  created(){
    document.title = 'iBookrestaurant | bind';
    if (this.$route.query&&this.$route.query.bindId)
    {
      localStorage.setItem('bindId',this.$route.query.bindId)
    }
    console.log(72,this.settings);
  },
  data () {
    return {
      page:'Auth',
      pushSubscribed:false,
      rs:null
    }
  },
methods:
    {
      async verifyPush()
      {
        try
        {
          //const res = await this.$http.post('/settings/settings_write.php', {"fieldname":fieldname,"fieldvalue":fieldvalue});
          let payload={"action":"verifyPush","bindId":localStorage.getItem("bindId")};
          let json=JSON.stringify(payload);
          console.log(91,'bind.vue',json);
          const res = await this.$http.post('/auth/signup.php', json);
          console.log(93,'response',res);
          this.rs=res;
          if (res.data.errorid=='0')
          {
            console.log(96)
            this.pushSubscribed=true;
            console.log(98,this.pushSubscribed)
          }
          else
          {
            this.snackbar_color='error'
            //this.$router.push('/auth/login').catch(() => {});
          }
          //this.message=res.data.message;
          //this.snackbar=true;
          return res.data;
        }
        catch(e)
        {
          console.log(e);
        }
      }, 
    }  
};
</script>
